const ItalicText = () => (
  <>
    <path
      fill="currentColor"
      d="M7.346 18.25a.54.54 0 0 1-.396-.162.54.54 0 0 1-.161-.397q0-.235.161-.396a.54.54 0 0 1 .396-.16h2.077l3.48-10.27h-2.076a.54.54 0 0 1-.396-.162.54.54 0 0 1-.162-.397q0-.235.162-.396a.54.54 0 0 1 .396-.16h5.192q.234 0 .396.162a.54.54 0 0 1 .162.397.54.54 0 0 1-.162.396.54.54 0 0 1-.396.16h-1.961l-3.481 10.27h1.962q.234 0 .396.162.16.162.161.397a.54.54 0 0 1-.162.396.54.54 0 0 1-.395.16z"
    />
  </>
)
export default ItalicText
